// extracted by mini-css-extract-plugin
export var change = "_47-1";
export var changeList = "_47-0";
export var changePath = "_47-2";
export var diffArrow = "_47-5";
export var diffRow = "_47-3";
export var diffValue = "_47-4";
export var error = "_47-8";
export var notice = "_47-9";
export var result = "_47-6";
export var success = "_47-7";